import { useState } from 'react'
import { useHotkey } from '@tanstack/react-hotkeys'
import { useCurrentUser } from './CurrentUserContext'

const STORAGE_KEY = 'show-hidden-notes'

/**
 * For Harry only: toggles visibility of hidden notes in the list/sidebar.
 * Hidden notes are always returned by the server for Harry, but this
 * controls whether they appear in the UI. Toggle with Ctrl+Shift+1 (Cmd+Shift+1 on Mac).
 */
export function useShowHiddenNotes() {
  const { currentUser } = useCurrentUser()
  const isHarry = currentUser === 'Harry'

  const [showHidden, setShowHidden] = useState(
    () => localStorage.getItem(STORAGE_KEY) === 'true',
  )

  useHotkey(
    'Mod+Shift+1',
    () => {
      setShowHidden((prev) => {
        const next = !prev
        localStorage.setItem(STORAGE_KEY, String(next))
        return next
      })
    },
    { enabled: isHarry },
  )

  return showHidden
}
